module.exports = __webpack_public_path__ + "img/auto3.f3587c88.jpg";